import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import Skeleton from "react-loading-skeleton";

export const MobileConfiguratorHeader = () => {
  const { selectedDoor } = useConfigurationOptionsContext();

  // Extract the product name
  const productName = selectedDoor?.name;

  // Show a skeleton loader if the product name is not available
  if (!productName) {
    return <Skeleton width={200} height={24} />;
  }

  // Render the product name if available
  return (
    <h2 className="gg-text-lg gg-font-bold gg-leading-6 gg-text-dark-blue">
      {productName}
    </h2>
  );
};
